<template>
    <div v-if="this.$store.state.loginInfo !== null && this.$store.state.loginInfo.token !== ''" class="wrap">
        <Navbar v-show="$route.path.substr(0,11)=='/backOffice' && $route.path!=='/backOffice' && $route.path!=='/backOffice/'"/>
        <div id=app v-if="$route.path.substr(0,11)=='/backOffice'">
            <div v-if="$route.path!=='/backOffice' && $route.path!=='/backOffice/'">
                <!-- lnb -->
                <Menu/>
                <!-- //lnb -->
                <!-- contents -->
                <div class="contents">
                    <!-- Main -->
                    <router-view :key="$route.fullPath"/>
                    <!-- Main -->
                    <!--                    <div class="footer3">
                                            © ILJIN ALL RIGHTS RESERVED.
                                        </div>-->
                </div>
            </div>
            <div v-else>
                <router-view :key="$route.fullPath"/>
            </div>
            <div class="vld-parent">
                <loading :active.sync="this.$store.state.isLoading"
                         :can-cancel="false"
                         :is-full-page="true"
                         color="#6799FF"
                         :opacity="0.1"></loading>
            </div>
        </div>
        <div v-else class="nlogin-main">
            <div v-bind:class="{'nlogin-main-first':$route.path=='/',
                                'nlogin-main-second':$route.path=='/ijmt',
                                'nlogin-main-ijst':$route.path=='/ijst',
                                'nlogin-main-ijel':$route.path=='/ijel',
                                'nlogin-main-ijhd':$route.path=='/ijhd',
                                'nlogin-main-ijdm':$route.path=='/ijdm',
                                'nlogin-main-ijap':$route.path=='/ijap',
                                'nlogin-main-third':$route.path=='/ijbh',
                                'nlogin-main-ijcs':$route.path=='/ijcs'
                               }">
                <VisitorNavbar/>
                <router-view :key="$route.fullPath"/>
<!--                <div class="footer2">
                    <span class="copyright">COPYRIGHT © ILJIN ALL RIGHTS RESERVED.</span>
                </div>-->
            </div>
        </div>
    </div>

    <div v-else class="nlogin">
        <div class="nlogin-main" v-if="$route.path.substr(0,11)=='/backOffice'">
            <div class="nlogin-main-first">
                <Login/>
                <div class="footer2">
                    <span class="copyright">COPYRIGHT © ILJIN ALL RIGHTS RESERVED.</span>
                </div>
            </div>
        </div>
        <div v-else class="nlogin-main">
            <div v-bind:class="{'nlogin-main-first':$route.path=='/',
                                'nlogin-main-second':$route.path=='/ijmt',
                                'nlogin-main-ijst':$route.path=='/ijst',
                                'nlogin-main-ijel':$route.path=='/ijel',
                                'nlogin-main-ijhd':$route.path=='/ijhd',
                                'nlogin-main-ijdm':$route.path=='/ijdm',
                                'nlogin-main-ijap':$route.path=='/ijap',
                                'nlogin-main-third':$route.path=='/ijbh',
                                'nlogin-main-ijcs':$route.path=='/ijcs'
                               }">
                <VisitorNavbar v-bind:propscomCodeInfo="this.comCodeInfo"/>
                <router-view :key="$route.fullPath" v-on:forwardCode="codeText"/>

<!--                <div class="footer2">
                    <span class="copyright">COPYRIGHT © ILJIN ALL RIGHTS RESERVED.</span>
                </div>-->
            </div>
        </div>

    </div>

</template>

<script>
    import Navbar from "@/components/Navbar.vue";
    import VisitorNavbar from "@/components/VisitorNavbar.vue";
    import Menu from "@/components/Menu.vue";
    import Login from "@/components/Login.vue";
    import MyMain from "@/views/MyMain.vue";
    import VisitorMain from "@/views/VisitorMain.vue";
    import router from './router';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: "App",
        components: {Navbar, Menu, Login, MyMain, VisitorMain, VisitorNavbar, Loading},
        data() {
            return {
                isOpen: true,
                route: router,
                isLoading: false,
                comCodeInfo : "",
            };

        },
        created() {
            if (!Array.prototype.filter) {
                Array.prototype.filter = function (func, thisArg) {
                    'use strict';
                    if (!((typeof func === 'Function' || typeof func === 'function') && this))
                        throw new TypeError();

                    var len = this.length >>> 0,
                        res = new Array(len), // preallocate array
                        t = this, c = 0, i = -1;

                    if (thisArg === undefined) {
                        while (++i !== len) {
                            // checks to see if the key was set
                            if (i in this) {
                                if (func(t[i], i, t)) {
                                    res[c++] = t[i];
                                }
                            }
                        }
                    } else {
                        while (++i !== len) {
                            // checks to see if the key was set
                            if (i in this) {
                                if (func.call(thisArg, t[i], i, t)) {
                                    res[c++] = t[i];
                                }
                            }
                        }
                    }

                    res.length = c; // shrink down array to proper size
                    return res;
                };
            }

            this.$http.defaults.headers['x-auth-token'] = this.$store.state.loginInfo.token;
            // server session check
            this.$http.get('/').catch((ex) => {
                this.$store.commit('logout');
                this.$cookie.delete('loginInfo');
            })

            if (this.$cookie.get('loginInfo') !== null) {
                this.$store.commit('login', JSON.parse(this.$cookie.get('loginInfo')));

                const loginInfo = {};
                loginInfo.loginId = this.$store.state.loginInfo.loginId;
                loginInfo.token = this.$store.state.loginInfo.token;
                loginInfo.menu = this.$store.state.loginInfo.menu;
                loginInfo.authorities = this.$store.state.loginInfo.authorities;
                loginInfo.loginPw = 'Not Use';
            }
        },
        mounted() {
            // eslint-disable-next-line
            dhtmlx.image_path = "/dhtmlx/imgs/";
            // eslint-disable-next-line
            dhtmlXCalendarObject.prototype.langData.ko = {
                // date format
                dateformat: "%Y-%m-%d",
                // full names of months
                monthesFNames: [
                    "1월",
                    "2월",
                    "3월",
                    "4월",
                    "5월",
                    "6월",
                    "7월",
                    "8월",
                    "9월",
                    "10월",
                    "11월",
                    "12월"
                ],
                // short names of months
                monthesSNames: [
                    "1월",
                    "2월",
                    "3월",
                    "4월",
                    "5월",
                    "6월",
                    "7월",
                    "8월",
                    "9월",
                    "10월",
                    "11월",
                    "12월"
                ],
                // full names of days
                daysFNames: [
                    "일요일",
                    "월요일",
                    "화요일",
                    "수요일",
                    "목요일",
                    "금요일",
                    "토요일"
                ],
                // short names of days
                daysSNames: ["일", "월", "화", "수", "목", "금", "토"],
                // starting day of a week. Number from 1(Monday) to 7(Sunday)
                weekstart: 1,
                // the title of the week number column
                weekname: "주"
            };
            // eslint-disable-next-line
            dhtmlXCalendarObject.prototype.lang = "ko";
            this.$store.commit('finish');
        },
        methods: {
            codeText(value){
                this.comCodeInfo = value.codeInfo
            }
        }
    };
</script>
<style>
    .nlogin{
        height:100%;
    }

    .nlogin-main{
        min-height: 100%;
        position: relative;
        padding-bottom: 59px;
    }

    .nlogin-main-first{
        width: 100%;
        height: 100%;
        #background: url('/img/iljin_building_1.png') no-repeat center;
        background-color: black;
        background-size: cover;
        position:absolute;
        min-height: 850px;
    }

    .nlogin-main-second{
        width: 100%;
        height: 100%;
        background: url('/img/iljinm_main_full.png') no-repeat center;
        background-size: cover;
        position:absolute;
        min-height: 850px;
    }

    .nlogin-main-ijst{
        width: 100%;
        height: 100%;
        background: url('/img/iljinst_main_full.png') no-repeat center;
        background-size: cover;
        position:absolute;
        min-height: 850px;
    }
    .nlogin-main-ijel{
        width: 100%;
        height: 100%;
        background: url('/img/iljinel_main_full.png') no-repeat center;
        background-size: cover;
        position:absolute;
        min-height: 850px;
    }
    .nlogin-main-ijhd{
        width: 100%;
        height: 100%;
        background: url('/img/iljinhd_main_full.png') no-repeat center;
        background-size: cover;
        position:absolute;
        min-height: 850px;
    }
    .nlogin-main-ijdm{
        width: 100%;
        height: 100%;
        background: url('/img/iljindm_main_full.png') no-repeat center;
        background-size: cover;
        position:absolute;
        min-height: 850px;
    }
    .nlogin-main-ijap{
        width: 100%;
        height: 100%;
        background: url('/img/iljinap_main_full.png') no-repeat center;
        background-size: cover;
        position:absolute;
        min-height: 850px;
    }

    .nlogin-main-third{
        width: 100%;
        height: 100%;
        background: url('/img/iljincomposite_main_full.png') no-repeat center;
        background-size: cover;
        position:absolute;
        min-height: 850px;
    }
    .nlogin-main-ijcs{
      width: 100%;
      height: 100%;
      background: url('/img/iljincs_main_full.png') no-repeat center;
      background-size: cover;
      position:absolute;
      min-height: 850px;
    }

    @media (min-width: 700px) {
        .nlogin-main-first{
            min-height: 1000px;
        }
        .nlogin-main-second{
            min-height: 1000px;
        }
        .nlogin-main-third{
            min-height: 1000px;
        }
        .nlogin-main-ijel{
            min-height: 1000px;
        }
        .nlogin-main-ijcs{
            min-height: 1000px;
        }
        .nlogin-main-ijdm{
            min-height: 1000px;
        }
        .nlogin-main-ijst{
            min-height: 1000px;
        }
        .nlogin-main-ijhd{
            min-height: 1000px;
        }
        .nlogin-main-ijap{
            min-height: 1000px;
        }
    }

    @media (min-width: 1000px) {
        .nlogin-main-first{
            min-height: 850px;
            height:100%;
        }
        .nlogin-main-second{
            min-height: 850px;
            height:100%;
        }
        .nlogin-main-third{
            min-height: 850px;
            height:100%;
        }
        .nlogin-main-ijel{
            min-height: 850px;
            height:100%;
        }
        .nlogin-main-ijcs{
            min-height: 850px;
            height:100%;
        }
        .nlogin-main-ijdm{
            min-height: 850px;
            height:100%;
        }
        .nlogin-main-ijst{
            min-height: 850px;
            height:100%;
        }
        .nlogin-main-ijhd{
            min-height: 850px;
            height:100%;
        }
        .nlogin-main-ijap{
            min-height: 850px;
            height:100%;
        }
    }

    .footer2{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }

</style>
